export default {"src":"/_next/static/media/businessArchiving.dc41c1d4.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};